import Vue from './app.js';
import {router} from './app.js';

export default {
  create(context, name, email, temps, nbjour, iduser, entitename, nbheure, utilisateurtemps, new_entites) {
    var entites = [];
    for (var i = new_entites.length - 1; i >= 0; i--) {
      entites.push(new_entites[i].value);
    };
    Vue.http.post(
      'api/client/new',
      {
        name: name,
        email: email,
        temps: temps,
        nbjour: nbjour,
        iduser: iduser,
        entitename: entitename,
        new_entites: entites,
        nbheure: nbheure,
        utilisateurtemps: utilisateurtemps,
      }
    ).then(response => {
      context.response = response.data;
			context.clients();
			context.showSuccessCreate();
      console.log(response);
		}, error => {
      if(error.status == 422){
          context.showErrorName();
      }else{
        context.showError();
        console.log(response.data);
      }
    })
  },
  update(context, id, name, email, temps, nbjour, iduser, entites, nbheure, utilisateurtemps, new_entites) {
    console.log(iduser);
    Vue.http.post(
      'api/client/update',
      {
        id: id,
        name: name,
        email: email,
        temps: temps,
        nbjour: nbjour,
        iduser: iduser,
        // entiteid: entiteid,
        entites: entites,
        nbheure: nbheure,
        utilisateurtemps: utilisateurtemps,
        new_entites: new_entites
        
      }
    ).then( response => {
      context.response = response.data
      console.log(response.data);
			if (context.response.error) {
				context.showError();
			}
			else {
				context.clients();
				context.showSuccessUpdate();
			}
		})
  },
  destroy(context, id, callback) {
    Vue.http.post(
      '/api/client/delete',
      {
          id: id
      }
    ).then(response => {
			context.response = response.data
        // context.clients();

        if (context.response.error) {
				context.showError();
			}
			else {
			    // if (!callback) {
    			// 	context.clients();
                // }
				context.showSuccessDelete();
				callback();
			}
		})
  }
}



// WEBPACK FOOTER //
// ./assets/js/clients.js